import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import CardTile from './Components/Tile';
import G172Cardtile from 'src/universal/components/Experiments/G172/Components/DesktopVariant';
import TrackScroll from './Components/TrackScroll';
import PageBreakBanner from '../PageBreakBanner';
import {
  showG162Banner,
  getLoadedIntoG162Experiment
} from 'src/universal/components/Experiments/G162/redux';
import { isG172Test } from 'src/universal/components/Experiments/G172/redux';
import { isCmPznBannerRenderable } from 'src/universal/components/CmBanner/redux';

import './__styles__/index.scss';

const HorizontalCardTiles = ({
  filteredCards,
  loadedIntoG162Experiment,
  showG162,
  cmBannerInfo,
  isG172Test
}) => {
  return (
    <div className="hctContainer">
      {filteredCards.map((shortName, id) => (
        <Fragment key={shortName}>
          <TrackScroll shortName={shortName} />
          {isG172Test ? (
            <G172Cardtile shortName={shortName} />
          ) : (
            <CardTile shortName={shortName} />
          )}
          {id === 1 &&
            !loadedIntoG162Experiment && (
              <PageBreakBanner
                mobile={false}
                renderCmBanner={cmBannerInfo?.renderable}
                isCm={cmBannerInfo?.isCm}
              />
            )}
          {id === 1 &&
            showG162 &&
            cmBannerInfo?.renderable && (
              <PageBreakBanner
                mobile={false}
                renderCmBanner={true}
                isCm={cmBannerInfo?.isCm}
              />
            )}
          {id === 2 &&
            showG162 && (
              <PageBreakBanner
                mobile={false}
                renderCmBanner={false}
                isCm={cmBannerInfo?.isCm}
              />
            )}
        </Fragment>
      ))}
    </div>
  );
};

const mapStateToProps = state => {
  const activeFilter = state?.filter?.activeFilter;
  return {
    loadedIntoG162Experiment: getLoadedIntoG162Experiment(state),
    showG162: showG162Banner(state, activeFilter),
    cmBannerInfo: isCmPznBannerRenderable(state),
    isG172Test: isG172Test(state)
  };
};

export default connect(mapStateToProps)(React.memo(HorizontalCardTiles));
